var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-layout",
    [
      _c("template", { slot: "page-header-right" }, [_c("auth-app-header")], 1),
      _vm._v(" "),
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          {
            staticClass: "col-xs-2 admin-layout-item",
            attrs: { id: "admin-menu" }
          },
          [_c("app-menu")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-10 admin-layout-item" }, [
          _c("div", { staticClass: "admin-page-container" }, [
            _c(
              "div",
              { staticClass: "row admin-page-header-container" },
              [
                _vm._t("admin-page-header", [
                  _vm._v("\n\t\t\t\t\t\t--admin-page-header--\n\t\t\t\t\t")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row  admin-page-content-container" },
              [
                _vm._t("admin-page-content", [
                  _vm._v("\n\t\t\t\t\t\t--admin-page-content--\n\t\t\t\t\t")
                ])
              ],
              2
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0cd2af8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0cd2af8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/AdminBaseLayout.vue
// module id = null
// module chunks = 